/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeservesPenaltyCommandResult } from '../../models/deserves-penalty-command-result';

export interface ApiKpiReportsDeservesPenaltyPost$Params {
      body?: {
'KPIId'?: string;
'DeservesPenalty'?: boolean;
}
}

export function apiKpiReportsDeservesPenaltyPost(http: HttpClient, rootUrl: string, params?: ApiKpiReportsDeservesPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DeservesPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsDeservesPenaltyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeservesPenaltyCommandResult>;
    })
  );
}

apiKpiReportsDeservesPenaltyPost.PATH = '/api/KPIReports/DeservesPenalty';
